import { useQuery } from '@tanstack/react-query';
import { IJob as IJobModel } from '~/models';
import { jobKeys } from '../jobKeys';
import { jobsService } from '../jobsService';

interface IUseGetJobOptions {
  enabled?: boolean;
}

export function useGetJob(jobId?: string, options: IUseGetJobOptions = {}) {
  return useQuery<IJobModel>({
    queryKey: jobKeys.detail(jobId ?? ''),
    queryFn: () => jobsService.getJob(jobId!),
    enabled: Boolean(jobId) && (options.enabled ?? true),
    staleTime: 1000 * 30,
    gcTime: 1000 * 60 * 2,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
